var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import clsx from 'clsx';
import React, { forwardRef, memo } from 'react';
import { combineProps, styled, useTheme, useThemeProps, withDeprecatedCheck, } from '../../../foundation';
import { RcIcon } from '../../Icon';
import { RcTooltip, withTooltip } from '../../Tooltip';
import { RcButtonBase } from '../ButtonBase';
import { rcIconButtonWarning, } from './deprecated/IconButtonProps';
import { iconButtonStyle } from './styles';
import { RcIconButtonClasses, RcIconButtonTouchRippleClasses } from './utils';
var _RcIconButton = memo(forwardRef(function (inProps, ref) {
    var _a;
    var props = useThemeProps({ props: inProps, name: 'RcIconButton' });
    var _b = props.buttonRef, buttonRef = _b === void 0 ? ref : _b, className = props.className, classes = props.classes, children = props.children, title = props.title, symbol = props.symbol, disabled = props.disabled, invisible = props.invisible, type = props.type, loading = props.loading, TouchRippleProps = props.TouchRippleProps, variant = props.variant, CircularProgressProps = props.CircularProgressProps, color = props.color, shouldPersistBg = props.shouldPersistBg, stretchIcon = props.stretchIcon, iconColor = props.iconColor, iconSize = props.iconSize, disableTouchRipple = props.disableTouchRipple, useColorWhenDisabled = props.useColorWhenDisabled, size = props.size, radius = props.radius, elevation = props.elevation, activeElevation = props.activeElevation, aRef = props.aRef, tooltipTitle = props.tooltipTitle, tooltipForceHide = props.tooltipForceHide, disableToolTip = props.disableToolTip, alwaysEnableTooltip = props.alwaysEnableTooltip, tooltipPlacement = props.tooltipPlacement, ariaLabel = props.ariaLabel, popperProps = props.popperProps, externalLink = props.externalLink, download = props.download, autoFocus = props.autoFocus, href = props.href, rest = __rest(props, ["buttonRef", "className", "classes", "children", "title", "symbol", "disabled", "invisible", "type", "loading", "TouchRippleProps", "variant", "CircularProgressProps", "color", "shouldPersistBg", "stretchIcon", "iconColor", "iconSize", "disableTouchRipple", "useColorWhenDisabled", "size", "radius", "elevation", "activeElevation", "aRef", "tooltipTitle", "tooltipForceHide", "disableToolTip", "alwaysEnableTooltip", "tooltipPlacement", "ariaLabel", "popperProps", "externalLink", "download", "autoFocus", "href"]);
    var theme = useTheme();
    var isOutline = variant === 'outline';
    var isContained = variant === 'contained';
    var isPlain = variant === 'plain';
    var IconClassName = clsx(className, classes.root, RcIconButtonClasses.root, (_a = {},
        _a[RcIconButtonClasses.disabled] = disabled,
        _a[RcIconButtonClasses.invisible] = invisible,
        _a[RcIconButtonClasses.outline] = isOutline,
        _a[RcIconButtonClasses.contained] = isContained,
        _a));
    var iconButton = (function () {
        var _a, _b;
        var icon = React.isValidElement(children) || children === '' ? children : (React.createElement(RcIcon, { symbol: symbol, className: classes.icon, loading: loading, CircularProgressProps: CircularProgressProps }, children));
        var iconButton = (React.createElement(RcButtonBase, __assign({ ref: buttonRef, disableRipple: ((_b = (_a = theme.props) === null || _a === void 0 ? void 0 : _a.MuiButtonBase) === null || _b === void 0 ? void 0 : _b.disableRipple) || isPlain, type: type, disabled: disabled, "aria-label": ariaLabel || tooltipTitle || title, title: title, "aria-disabled": disabled, className: IconClassName, TouchRippleProps: combineProps({
                classes: RcIconButtonTouchRippleClasses,
            }, TouchRippleProps) }, rest), icon));
        if (download && href) {
            return (React.createElement("a", { download: true, href: href, ref: aRef }, iconButton));
        }
        if (externalLink && href) {
            return (React.createElement("a", { rel: "noopener noreferrer external", target: "_blank", href: href }, iconButton));
        }
        return iconButton;
    })();
    if (!!tooltipTitle &&
        ((!disabled && !disableToolTip) || (disabled && alwaysEnableTooltip))) {
        return (React.createElement(RcTooltip, { title: tooltipTitle, tooltipForceHide: tooltipForceHide, placement: tooltipPlacement, PopperProps: popperProps }, iconButton));
    }
    return iconButton;
}));
var RcIconButton = styled(withDeprecatedCheck(withTooltip(_RcIconButton), 
// TODO remove when ready
rcIconButtonWarning, 'RcIconButton'))(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), iconButtonStyle);
RcIconButton.displayName = 'RcIconButton';
RcIconButton.defaultProps = {
    variant: 'round',
    color: 'neutral.f04',
    size: 'medium',
    type: 'button',
    focusRipple: true,
    disableTouchRipple: true,
    centerRipple: true,
    classes: {},
    useRcTooltip: true,
};
export { RcIconButton, };
var templateObject_1;
